//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function() {
  const curalate = angular.module('curalate');

    /*
     * This directive is used to conditionally disable inputs and buttons based on the required
     * permissions for a page and the permissions the user has. In order for this directive to
     * work, the permission must be listed in CLIENT_PERMISSION_CHECKS in JsSessionVars.scala.
     *
     * To use this directive, simply pass a comma separated list of task names like so...
     *
     * <input class="foo" required-permissions="TaskName1,TaskName2" />
     *
     * You may also attach a 'requiredPermissionsDisabledWhen' attribute which will disable the element based on the
     * value passed to it. If the value is 'true', the element is disabled but without any tooltips. Otherwise
     * the required permissions are checked. This is to mimic ng-disabled on permissioned elements.
     *
     */
  curalate.directive('requiredPermissions', [
    '$compile',
    'PermissionsService',
    function(
            $compile,
            PermissionsService,
        ) {
      return {
        restrict: 'A',
        scope: {
          requiredPermissions: '@',
          requiredPermissionsDisabledTooltip: '@',
          requiredPermissionsDisabledWhen: '=',
          requiredPermissionsEnabledTooltip: '@',
          requiredPermissionsTooltipPlacement: '@',
        },
        link(scope, elem) {
          let tooltipWrapperElem;
          let disabledElem;
          const DEFAULT_TOOLTIP_TEXT = "You don't have permission to take this action. Contact a group admin if this is a mistake.";

          const requiredPermissions = _.chain(scope.requiredPermissions.replace(/ /g, '').split(',')).compact().value();
          const lacksRequiredPermissions = _.chain(requiredPermissions)
                        .map(permission => PermissionsService.hasPermissionForTask(permission))
                        .contains(false)
                        .value();
          const hasRequiredPermissions = !lacksRequiredPermissions;

          if (lacksRequiredPermissions) {
            disabledElem = elem
                        .attr('disabled', true)
                        .css('position', 'relative')
                        .addClass('required-permissions');
            tooltipWrapperElem = $compile(
                        angular.element('<span>')
                            .attr('tooltip', scope.requiredPermissionsDisabledTooltip || DEFAULT_TOOLTIP_TEXT)
                            .attr('tooltip-append-to-body', true)
                            .attr('tooltip-trigger', '')
                            .attr('tooltip-placement', scope.requiredPermissionsTooltipPlacement || 'top')
                            .addClass('required-permissions-input'),
                    )(scope);

                    // The browser treats disabled inputs and button differently, so we have to
                    // add the tooltips differently.
            if (elem.prop('tagName') === 'INPUT') {
              elem.replaceWith(tooltipWrapperElem);
              tooltipWrapperElem.append(disabledElem);
            } else if (elem.prop('tagName') === 'BUTTON') {
              elem.replaceWith(tooltipWrapperElem.css('display', 'inline-block'));
              tooltipWrapperElem.append(disabledElem);
            } else if (elem.prop('tagName') === 'TD') {
              tooltipWrapperElem.append(disabledElem.contents());
              disabledElem.append(tooltipWrapperElem.addClass('required-permissions-button'));
                        // Disable all click listening events on this td element if we have don't have permission to press it
              disabledElem.bind('click', (e) => {
                e.stopImmediatePropagation();
                return false;
              });
            } else if (elem.prop('tagName') === 'LI') {
              tooltipWrapperElem.append(disabledElem.contents());
              disabledElem.append(tooltipWrapperElem);
                        // Disable all click listening events on this td element if we have don't have permission to press it
              disabledElem.bind('click', (e) => {
                e.stopImmediatePropagation();
                return false;
              });
            }
          }

                // If the user has permissions, conditionally enable / disable the input
                // based on the value of requiredPermissionsDisabledWhen. Also add the
                // "enabled" state tooltip.
          if (hasRequiredPermissions) {
            if (scope.requiredPermissionsEnabledTooltip) {
              $compile(elem.removeAttr('required-permissions')
                        .attr('tooltip', scope.requiredPermissionsEnabledTooltip)
                        .attr('tooltip-trigger', '')
                        .attr('tooltip-placement', scope.requiredPermissionsTooltipPlacement || 'top'))(scope);
            }
            scope.$watch('requiredPermissionsDisabledWhen', () => {
              elem.attr('disabled', !!scope.requiredPermissionsDisabledWhen);
            });
          }
        },
      };
    }]);
})();

